import React from 'react';
import MetaTags from '../../../components/MetaTags';
import { useProfileDetails } from './useProfileDetails';
import { ProfileDetailsView } from './ProfileDetailsView';

export const ProfileDetails: React.FC = () => {
    const { metaTags, ...viewProps } = useProfileDetails();
    return (
        <React.Fragment>
            <MetaTags {...metaTags} />
            <ProfileDetailsView {...viewProps} />
        </React.Fragment>
    );
};
